import { useUIStore } from '@/store/uiStore'
import { Loader2 } from 'lucide-react'

const GlobalLoading = () => {
  const { globalLoading, loadingMessage } = useUIStore()

  if (!globalLoading) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-6 flex flex-col items-center gap-3 shadow-xl">
        <Loader2 size={32} className="animate-spin text-bsnl-primary" />
        <p className="text-gray-700 font-medium">
          {loadingMessage || 'Loading...'}
        </p>
      </div>
    </div>
  )
}

export default GlobalLoading
